import { Directive } from '@angular/core';
@Directive({
  selector: '[fLogoContainer]'
})
export class LogoContainerDirective {}
